import React from 'react';
import {TechnicalDetailsFeatureAppDependencies} from './';

export const FeatureServicesContext = React.createContext<
  TechnicalDetailsFeatureAppDependencies | undefined
>(undefined);

export function useFeatureServices(): TechnicalDetailsFeatureAppDependencies {
  const featureServices = React.useContext(FeatureServicesContext);

  if (!featureServices) {
    throw new Error('No featureServices context value was provided.');
  }

  return featureServices;
}
